import type { MapReadAddress } from '@/types/mapReadAddress';

export const READ_ONLY_ADDRESS_EMPTY = 'Sin dirección';

export type ParsedReadOnlyAddress = {
  display: string;
  neighborhood?: string;
  mapMarker: { lat: number; lng: number; label: string } | null;
};

function parseCoord(
  coordinateRaw: string | number | null | undefined
): number | null {
  if (coordinateRaw == null || coordinateRaw === '') return null;
  const parsedNumber =
    typeof coordinateRaw === 'number'
      ? coordinateRaw
      : parseFloat(String(coordinateRaw).replace(',', '.'));
  return Number.isFinite(parsedNumber) ? parsedNumber : null;
}

function streetLine(mapAddress: MapReadAddress): string {
  const streetDoorJoined = [
    mapAddress.streetName,
    mapAddress.doorNumber,
    mapAddress.apartmentNumber,
  ]
    .filter(Boolean)
    .join(' ');
  return streetDoorJoined || READ_ONLY_ADDRESS_EMPTY;
}

export function parseReadOnlyAddress(address?: MapReadAddress | null): ParsedReadOnlyAddress {
  if (!address) {
    return { display: READ_ONLY_ADDRESS_EMPTY, neighborhood: undefined, mapMarker: null };
  }

  const street = streetLine(address);
  const city = address.neighborhood?.city?.name?.trim();
  const display = city ? `${street} - ${city}` : street;
  const neighborhoodName = address.neighborhood?.name?.trim();

  const latitude = parseCoord(address.lat);
  const longitude = parseCoord(address.long);
  if (latitude == null || longitude == null) {
    return {
      display,
      neighborhood: neighborhoodName || undefined,
      mapMarker: null,
    };
  }

  const labelParts = [
    street !== READ_ONLY_ADDRESS_EMPTY ? street : null,
    neighborhoodName,
  ].filter(Boolean);
  const markerLabel = labelParts.join(' - ') || READ_ONLY_ADDRESS_EMPTY;

  return {
    display,
    neighborhood: neighborhoodName || undefined,
    mapMarker: { lat: latitude, lng: longitude, label: markerLabel },
  };
}
